import { ISearchable } from './Searchable.itf'

/**
* @typedef  PoissonConstructor
* @type {object}
* @property {number} idPoisson - the idPoisson value
* @property {number} idCategoriePoisson - the idCategoriePoisson value
* @property {string} codeFao - the codeFao value
* @property {string} codeArt - the codeArt value
* @property {string} facultatif - the facultatif value
* @property {number} ponderation - the ponderation value
* */

export class Poisson extends ISearchable {
  /**
   * Creates an instance of Poisson.
   * @memberof Poisson
   * */
  constructor(object) {
    super()

    this.idPoisson = object.idPoisson
    this.idCategoriePoisson = object.idCategoriePoisson
    this.codeFao = object.codeFao
    this.codeArt = object.codeArt
    this.facultatif = object.facultatif
    this.ponderation = object.ponderation
    this.latin = object.latin
    this.denom = object.denom
  }

  formatToDisplay() {
    this.nom = this.denom.map(element => element.nom.charAt(0).toUpperCase() + element.nom.substring(1).toLowerCase()).join(' / ')

    this.raccourci = this.denom[0].raccourci || this.nom
    this.lineClassName = 'fishLine'
    this.boxClassName = 'fishBox'
    this.displayType = this.latin.map(elem => elem.nom).join(', ')
    this.created = true
    return this
  }

  formatToCreate() {
    this.formatToDisplay()
    this.created = false
    this.lineClassName = 'create-fishLine'
    this.boxClassName = 'create-fishBox'
    return this
  }

  getNameAttribute() {
    return 'nom'
  }

  getIdAttribute() {
    return 'idPoisson'
  }

  getRaccourciAttribute() {
    return 'raccourci'
  }
}
